/** Standard 16:9 slide for PPTX (inches) — 10" × 5.625". */
export const SURF_PPTX_SLIDE_WIDTH_IN = 10;
export const SURF_PPTX_SLIDE_HEIGHT_IN = 5.625;
export function normRectToPptxIn(rect) {
    return {
        x: rect.x * SURF_PPTX_SLIDE_WIDTH_IN,
        y: rect.y * SURF_PPTX_SLIDE_HEIGHT_IN,
        w: rect.w * SURF_PPTX_SLIDE_WIDTH_IN,
        h: rect.h * SURF_PPTX_SLIDE_HEIGHT_IN,
    };
}
/** Font size in points from relative text role (aligned with PDF export). */
export function pptxFontSizePt(sizeRel) {
    const slideHeightPt = SURF_PPTX_SLIDE_HEIGHT_IN * 72;
    return Math.max(8, Math.round(sizeRel * slideHeightPt));
}
/** PowerPoint-safe font faces — PptxGenJS does not embed custom fonts. */
export function pptxFontFace(font) {
    const f = font.toLowerCase();
    if (f.includes("courier") || f.includes("mono"))
        return "Courier New";
    if (f.includes("georgia") || f.includes("serif"))
        return "Georgia";
    return "Arial";
}
/** PptxGenJS color without # prefix. */
export function hexToPptxColor(hex) {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
    return m ? m[1].toUpperCase() : "1E293B";
}
